import actions from './actionTypes';
import * as Constants from '../utilities/constants/Constants';
import {
  hasRip,
  getPremiumContentList,
  isSignageSizeSelectionPage,
  isSignageProductSelectionPage,
  getArrayOfEachPremiumContent,
  isModelPage,
  isCanvasAppFromURL
} from '../utilities/HelperFunctions/HelperFunctions';
import { finalCheckIsClicked, onEditDesign } from './finalCheckActions';
import { string } from '../localization';
import {
  postVanillaProjectDetails,
  handleAddPrinterWindow
} from './vanillaDesignActions';
import {
  selectPresetWall,
  modelIsSelected,
  isPresetSizeAvailableInLaunch,
  filterSupportedProducts,
  isProductSingle
} from './homeActions';
import { tabChangeGA } from '../utilities/GAHelpers/GAHelpers';
import * as api from '../services/api';
import { getPlacings } from './ProjectData/Project';
import { isWallLayout } from './fabricCanvasActionHelpers';
import {
  isCanvasApp,
  shouldShowSizeList
} from '../utilities/HelperFunctions/SignageHelperFunctions';
import { resetMultiCanvasErrorState } from './actions/sizeHandler';

const nextButtonActionForModalPage = () => (dispatch, getState) => {
  dispatch(setCurrentPageIndex(Constants.DESIGN_PAGE));

  if (getState().pageController.isPresetSizePage) {
    dispatch(selectPresetWall());
  }
};

export const setUpPages = () => (dispatch, getState) => {
  const pageDictionary = [
    {
      id: Constants.PRODUCT_GROUP_PAGE,
      click: () => dispatch(setCurrentPageIndex(Constants.PRODUCT_GROUP_PAGE)),
      nextBtnTitle: string.NEXT_BUTTON_TITLE_KEY
    },
    {
      id: Constants.PRODUCT_LIST_PAGE,
      click: () => dispatch(setCurrentPageIndex(Constants.PRODUCT_LIST_PAGE)),
      nextBtnTitle: string.NEXT_BUTTON_TITLE_KEY
    },
    {
      id: Constants.SIZE_SELECTION_PAGE,
      click: () => dispatch(setCurrentPageIndex(Constants.SIZE_SELECTION_PAGE)),
      nextBtnTitle: string.NEXT_BUTTON_TITLE_KEY
    },
    {
      id: Constants.DESIGN_PAGE,
      click: () => dispatch(nextButtonActionForModalPage()),
      nextBtnTitle: string.NEXT_BUTTON_TITLE_KEY
    },
    {
      id: Constants.FINAL_CHECK_PAGE,
      click: () => finalCheckIsClicked(continueFinalCheck, dispatch, getState),
      nextBtnTitle: string.FINISH_KEY
    },
    {
      id: Constants.INITIAL_PRINT_PAGE,
      click: () => dispatch(checkForPrinterOptions()),
      nextBtnTitle: string.SEND_TO_PRINT_TITLE_KEY
    },
    {
      id: Constants.FILE_PROCESSING_PAGE,
      click: () => dispatch(postVanillaProjectDetails()),
      nextBtnTitle: string.NEXT_BUTTON_TITLE_KEY
    },
    {
      id: Constants.DESIGN_SHARE_PAGE,
      click: () => dispatch(setCurrentPageIndex(Constants.DESIGN_SHARE_PAGE)),
      nextBtnTitle: string.NEXT_BUTTON_TITLE_KEY
    },
    {
      id: Constants.PRINT_PAGE,
      click: () => setCurrentPageIndex(Constants.PRINT_PAGE),
      nextBtnTitle: string.NEXT_BUTTON_TITLE_KEY
    },
    {
      id: Constants.THANK_YOU_PAGE,
      // click: this.props.dispatchers.saveIsClicked
      nextBtnTitle: string.NEXT_BUTTON_TITLE_KEY
    }
  ];
  dispatch({
    type: actions.SETUP_PAGES,
    payload: {
      pages: pageDictionary
    }
  });
};

export const setCurrentPageIndex = index => (dispatch, getState) => {
  const { envData } = getState().modal;
  if (index === Constants.FINAL_CHECK_PAGE) {
    api.getProjectReviewedStatus(getState().finalCheck.project.token);
    dispatch(tabChangeGA());
  }
  if (index == Constants.PRODUCT_GROUP_PAGE) {
    dispatch(resetMultiCanvasErrorState());
  }

  dispatch({
    type: actions.SET_ACTIVE_OBJECT,
    payload: {
      activeObject: null
    }
  });
  dispatch({
    type: actions.SET_PAGE_INDEX,
    payload: {
      currentPageIndex: index
    }
  });

  if (
    envData.wallart_lite_web_link &&
    envData.product_width !== '' &&
    envData.product_height !== ''
  ) {
    dispatch(updateBottomBarState(index, true));
  } else {
    dispatch(updateBottomBarState(index, false));
  }
};

export const goToNextPage = () => (dispatch, getState) => {
  const { pages, currentPageIndex } = getState().pageController;
  const { canvasType } = getState().home;
  const nextPage =
    canvasType == Constants.MULTI_CANVAS &&
    currentPageIndex === Constants.PRODUCT_GROUP_PAGE
      ? Constants.SIZE_SELECTION_PAGE
      : currentPageIndex + 1;
  pages[nextPage].click();
};

export const goToPrevPage = () => (dispatch, getState) => {
  const { pages, currentPageIndex } = getState().pageController;
  const { envData } = getState().modal;
  const { selectedProduct } = getState().home;
  const { project } = getState().finalCheck;

  let prevPageIndex = currentPageIndex;
  if (
    isSignageSizeSelectionPage(selectedProduct, currentPageIndex) ||
    isSignageProductSelectionPage(selectedProduct, currentPageIndex)
  ) {
    prevPageIndex = currentPageIndex - 1;
  }
  if (
    (isCanvasAppFromURL() || isCanvasApp(project.category)) &&
    currentPageIndex === Constants.SIZE_SELECTION_PAGE
  ) {
    prevPageIndex = Constants.PRODUCT_GROUP_PAGE;
  }
  if (currentPageIndex === Constants.DESIGN_PAGE) {
    dispatch(modelIsSelected());
  } else if (currentPageIndex === Constants.FINAL_CHECK_PAGE) {
    dispatch(
      onEditDesign(param => {
        dispatch(setCurrentPageIndex(param));
      }, envData.category)
    );
  } else pages[prevPageIndex].click();
};

export const setModalPageMode = index => dispatch => {
  dispatch({
    type: actions.SET_MODAL_PAGE_MODE,
    payload: { modalMode: index }
  });
};

export const updateBottomBarState = (currentPage, isWeblink) => dispatch => {
  switch (currentPage) {
    case Constants.PRODUCT_GROUP_PAGE:
    case Constants.PRODUCT_LIST_PAGE:
    case Constants.SIZE_SELECTION_PAGE:
      if (isWeblink) {
        dispatch({
          type: actions.SET_BOTTOM_BAR_STATUS,
          payload: { 1: 'nohover', 2: 'nohover', 3: 'nohover' }
        });
      } else {
        dispatch({
          type: actions.SET_BOTTOM_BAR_STATUS,
          payload: { 1: 'active', 2: 'nohover', 3: 'nohover' }
        });
      }
      break;
    case Constants.DESIGN_PAGE:
      if (isWeblink) {
        dispatch({
          type: actions.SET_BOTTOM_BAR_STATUS,
          payload: { 1: 'nohover', 2: 'active', 3: 'hover' }
        });
      } else {
        dispatch({
          type: actions.SET_BOTTOM_BAR_STATUS,
          payload: { 1: 'hover', 2: 'active', 3: 'hover' }
        });
      }
      break;
    case Constants.FINAL_CHECK_PAGE:
      if (isWeblink) {
        dispatch({
          type: actions.SET_BOTTOM_BAR_STATUS,
          payload: { 1: 'nohover', 2: 'hover', 3: 'active' }
        });
      } else {
        dispatch({
          type: actions.SET_BOTTOM_BAR_STATUS,
          payload: { 1: 'hover', 2: 'hover', 3: 'active' }
        });
      }
      break;
    default:
      break;
  }
};

const continueFinalCheck = () => dispatch => {
  dispatch(setCurrentPageIndex(Constants.FINAL_CHECK_PAGE));
};

export const checkForPrinterOptions = () => (dispatch, getState) => {
  const storeId = getState().modal.storeData.id;
  const placings = getPlacings(getState().finalCheck.project);
  const premiumContents = getPremiumContentList(placings);
  const congratulationsPage = getState().pageController.showCongratulationsPage;
  if (premiumContents.length > 0 && congratulationsPage) {
    dispatch(setCurrentPageIndex(Constants.FINAL_CHECK_PAGE));
    dispatch(redirectToCongratulationsPage(false));
  } else if (!getState().modal.storeData.hasLitePartnerPrinter) {
    dispatch(handleAddPrinterWindow(true));
  } else if (hasRip(storeId) !== null) {
    dispatch(postVanillaProjectDetails());
  } else {
    dispatch(setCurrentPageIndex(Constants.INITIAL_PRINT_PAGE));
  }
};

export const redirectToCongratulationsPage = condition => dispatch => {
  dispatch({
    type: actions.REDIRECT_TO_CONGRATULATIONS_PAGE,
    payload: condition
  });
};

export const checkForPremiumLogin = premiumContentList => (
  dispatch,
  getState
) => {
  const {
    loggedInToPattren,
    loggedInToVecteezy,
    loggedInToDreamstime,
    loggedInToAdobeStock
  } = getState().modal.envData;
  return (
    (getArrayOfEachPremiumContent(premiumContentList, Constants.VECTEEZY_TYPE)
      .length > 0
      ? !loggedInToVecteezy
      : false) ||
    (getArrayOfEachPremiumContent(
      premiumContentList,
      Constants.PATTERN_DESIGN_IMAGE_SOURCE
    ).length > 0
      ? !loggedInToPattren
      : false) ||
    (getArrayOfEachPremiumContent(
      premiumContentList,
      Constants.DREAMSTIME_IMAGE_SOURCE
    ).length > 0
      ? !loggedInToDreamstime
      : false) ||
    (getArrayOfEachPremiumContent(
      premiumContentList,
      Constants.ADOBE_STOCK_IMAGE_SOURCE
    ).length > 0
      ? !loggedInToAdobeStock
      : false)
  );
};

export const disableNextForCustom = () => (dispatch, getState) => {
  const { isPresetSizePage } = getState().pageController;
  const { variableSizeType } = getState().modal.storeData;
  // If it is Model selection page not custom one
  if (isPresetSizePage) {
    if (dispatch(isPresetSizeAvailableInLaunch(variableSizeType))) {
      return false;
    }
  }
  return true;
};

export const disableNextForModalPage = () => (dispatch, getState) => {
  const {
    selectedProduct,
    customWall,
    canvasWall,
    multiCanvasPopoverStatus
  } = getState().home;
  const { currentPageIndex } = getState().pageController;
  let disable;
  if (isModelPage(currentPageIndex)) {
    if (isSignageProductSelectionPage(selectedProduct, currentPageIndex)) {
      disable = true;
    } else if (multiCanvasPopoverStatus) {
      const { rowValid, columnValid } = getState().home.multiCanvas;
      disable =
        rowValid !== '' ||
        columnValid != '' ||
        currentPageIndex == Constants.SIZE_SELECTION_PAGE;
    } else {
      const { customHeight, customWidth, widthValid, heightValid } = customWall;
      const {
        canvasWallWidth,
        canvasWallHeight,
        canvasWallWidthValid,
        canvasWallHeightValid
      } = canvasWall;

      const isCustomSizeError =
        widthValid != '' ||
        heightValid != '' ||
        !(customHeight && customWidth) ||
        Number.isNaN(customWidth) ||
        Number.isNaN(customHeight);

      const isWallSizeError =
        canvasWallWidthValid != '' ||
        canvasWallHeightValid != '' ||
        !(canvasWallHeight && canvasWallWidth) ||
        Number.isNaN(canvasWallWidth) ||
        Number.isNaN(canvasWallHeight);

      if (dispatch(shouldShowSizeList())) {
        disable = isCustomSizeError || isWallSizeError;
      } else {
        disable =
          dispatch(disableNextForCustom()) &&
          (isCustomSizeError || isWallSizeError);
      }
    }
  }
  return disable;
};

export const doesProjectHasNoContents = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  let hasNoObjects = true;
  if (wallCanvas) {
    wallCanvas.getObjects().forEach(obj => {
      const isPlacingPresent = Object.prototype.hasOwnProperty.call(
        obj,
        'placing'
      );
      if (isPlacingPresent && !isWallLayout(obj)) {
        hasNoObjects = false;
      }
    });
  }
  return hasNoObjects;
};

export const shouldDisableNextButton = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const isEmptyProject = Object.keys(project).length === 0;

  if (getState().modal.envData && !isEmptyProject) {
    const { currentPageIndex } = getState().pageController;
    const { isVanilla } = getState().modal.envData;
    const premiumContentList = getPremiumContentList(
      project && getPlacings(project) ? getPlacings(project) : null
    );
    if (
      dispatch(disableNextForModalPage()) ||
      (currentPageIndex === Constants.FINAL_CHECK_PAGE &&
        isVanilla &&
        dispatch(checkForPremiumLogin(premiumContentList))) ||
      (currentPageIndex === Constants.DESIGN_PAGE &&
        dispatch(doesProjectHasNoContents())) ||
      currentPageIndex === Constants.PRODUCT_LIST_PAGE
    ) {
      return true;
    }
    return false;
  }
  return true;
};

export const canShowNextButton = () => (dispatch, getState) => {
  const { currentPageIndex } = getState().pageController;
  return (
    currentPageIndex != Constants.FILE_PROCESSING_PAGE &&
    currentPageIndex != Constants.DESIGN_SHARE_PAGE &&
    (currentPageIndex != Constants.FINAL_CHECK_PAGE ||
      getState().modal.envData.is_vanilla_designer)
  );
};

export const canShowPreviousButton = () => (dispatch, getState) => {
  const { currentPageIndex } = getState().pageController;
  const { storeData } = getState().modal;
  const { project } = getState().finalCheck;
  const { selectedProduct } = getState().home;
  if (
    isSignageSizeSelectionPage(selectedProduct, currentPageIndex) ||
    isSignageProductSelectionPage(selectedProduct, currentPageIndex)
  ) {
    const filteredProducts = dispatch(
      filterSupportedProducts(storeData.supportedProducts)
    );

    const isSingle = dispatch(isProductSingle(filteredProducts));
    return !isSingle;
  }
  if (
    (isCanvasAppFromURL() || isCanvasApp(project.category)) &&
    currentPageIndex === Constants.SIZE_SELECTION_PAGE
  ) {
    return true;
  }
  if (
    currentPageIndex === Constants.FINAL_CHECK_PAGE ||
    currentPageIndex === Constants.DESIGN_PAGE
  ) {
    return true;
  }
  return false;
};
